

import * as Yup from "yup";

export const formikNotes = {
  initialValues: {
    _id: null,
    name: "",
    description: "",
    category: "",
    created_by: "",
    image: null,
  },
  validationSchema: Yup.object({
    name: Yup.string()
      .required("Required Field")
      .max(60, "Name cannot be more than 60 characters"),
    description: Yup.string()
      .required("Required Field")
      .max(120, "Description cannot be more than 120 characters"),
  }),
};
